import React, {FC} from "react"

import {StyledMessage} from "./styled"

interface Props {
  message: string
}

const ContentMessage: FC<Props> = ({message}) => <StyledMessage>{message}</StyledMessage>

export default ContentMessage
